var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/searchProductPageNew.8f1d1df3.png","uri@2x": __webpack_public_path__ + "static/media/searchProductPageNew.33b8495c.png","uri@3x": __webpack_public_path__ + "static/media/searchProductPageNew.ae1bc60b.png",
    width: 24,
    height: 24
});